import { render, staticRenderFns } from "./ChatFilledIcon.vue?vue&type=template&id=0b1bc7f6&"
import script from "./ChatFilledIcon.vue?vue&type=script&lang=ts&"
export * from "./ChatFilledIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports